import { Result } from '@/classes/Result'
import { fetchAPI } from '@/utils/useAPI'
import { IConversationMessage, IUser, MutableChannels, UserJourney, UserMuteChannel } from '@/classes'
import { INotificationQueue } from '@/classes/Notification'

export interface UserUpdatesAPI {
	messages: IConversationMessage[]
	user: IUser | null
	notificationQueue: INotificationQueue[]
	conversationsCount: number
	followerCount: number
	followingCount: number
	postCount: number
	hasPartners: boolean
	hasClubPartners: boolean
}

export const updateJourneyAPI = async (
	type: typeof UserJourney[number] | 'offer'
) => {
	const response: Result<{
		user: IUser | null
	}> = await fetchAPI('user/journey', { type }, { method: 'POST' })

  return response
}

export const addDeviceAPI = async (
	device: {
		id: string
		name: string
		token: string
	}
) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user/devices/add', { device }, { method: 'POST' })

	return response
}

export const resetDeviceAPI = async () => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user/devices/reset')

	return response
}

export const refreshDeviceAPI = async (
	id: string, token: string
) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user/devices/refresh', { id, token }, { method: 'POST' })

	return response
}

export const toggleDeviceAPI = async (
	id: string, action: 'enable' | 'disable'
) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user/devices/toggle', { id, action }, { method: 'POST' })

	return response
}

export const deleteUserAPI = async (
	token?: string,
	reasons?: string[]
) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user', { ...(token ? { token } : {}), reasons }, { method: 'DELETE' })

	return response
}

export const blockUserAPI = async (userId: string) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user/block', { userId }, { method: 'POST' })

	return response
}

export const unblockUserAPI = async (userId: string) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user/unblock', { userId }, { method: 'POST' })

	return response
}

export const getUserUpdatesAPI = async (isActive: boolean) => {
	const response: Result<UserUpdatesAPI> = await fetchAPI('user/updates', { isActive })

	return response
}

export const muteChannelAPI = async (params: {
	_id?: string
	value?: string
	type: typeof MutableChannels[number]
	mute: 'hours' | 'week' | 'indefinite' | 'unmute'
	token?: string
}) => {
	const response: Result<{ user: IUser }> = await fetchAPI('user/mute', params, { method: 'POST' })

	return response
}

export const getPreferencesAPI = async (token: string) => {
	const response: Result<{ channels: UserMuteChannel[] | null }> = await fetchAPI('user/preferences', { token })

	return response
}

export const userFollowingGetAPI = async () => {
	const response: Result<{
		following: string[]
		followers: string[]
		mutuals: string[]
		followingOrganizations: string[]
		followingPlaces: string[]
	}> = await fetchAPI('user/following')

	return response
}

export const userReferralsGetAPI = async () => {
	const response: Result<{
		referralCount: number
		referralAmount: number
		referralAmountTotal: number
	}> = await fetchAPI('user/referrals/get', {}, { method: 'POST' })

	return response
}

export const userReferralsRedeemAPI = async () => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('user/referrals/redeem', {}, { method: 'POST' })

	return response
}

export const userNonprofitAmountGetAPI = async () => {
	const response: Result<{
		amount: number
	}> = await fetchAPI('user/nonprofit')

	return response
}